import { h } from '@logicflow/core';
import { RectResize } from '@logicflow/extension/es/NodeResize';
import { getThemeStyle } from '../theme';

const { view: RectResizeView, model: RectResizeModel } = RectResize;

class GroupView extends RectResizeView {
  getResizeShape() {
    const { model } = this.props;
    const { x, y, width, height } = model;
    const style = model.getNodeStyle();

    return h('g', {}, [
      h('rect', {
        x: x - width / 2,
        y: y - height / 2,
        width,
        height,
        rx: 8,
        ry: 8,
        ...style,
      }),
    ]);
  }
}

class GroupModel extends RectResizeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = data.properties?.width || 300;
    this.height = data.properties?.height || 200;
    this.minWidth = 100;
    this.minHeight = 80;
    this.maxWidth = 2000;
    this.maxHeight = 1500;
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'group');
    style.stroke = t.stroke || '#555';
    style.strokeWidth = t.strokeWidth ?? 1.5;
    style.strokeDasharray = '8,4';
    style.fill = t.fill || 'none';
    return style;
  }

  getResizeOutlineStyle() {
    return { stroke: '#1890ff', strokeWidth: 1, strokeDasharray: '3,3' };
  }
}

export const Group = {
  type: 'epx:Group',
  view: GroupView,
  model: GroupModel,
};
